import { render, staticRenderFns } from "./MenuChange.vue?vue&type=template&id=53773ec2&scoped=true&"
import script from "./MenuChange.vue?vue&type=script&lang=js&"
export * from "./MenuChange.vue?vue&type=script&lang=js&"
import style0 from "./MenuChange.vue?vue&type=style&index=0&id=53773ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53773ec2",
  null
  
)

export default component.exports